import request from '../request'
import config from '@/config/index'
const { apiPath } = config

// AI分析接口
export const aiAnalysis = (params: { type: string; symbol: string }) => {
  return request({
    url: `${apiPath('api')}/score/Analysis`,
    method: 'post',
    timeout: 120000, // 120秒超时
    data: {
      ...params,
      noMessage: {
        noLoading: 1,
        noSuccess: 1
      }
    }
  })
}
